import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6uxa229g: FaireBrandEntity = {
  token: "b_6uxa229g",
  type: "brand",
  name: "Haute Diggity Dog",
  avatarUrl: "https://cdn.faire.com/fastly/93c332c88a8735ba43f84251913dda2077aa173322778b8f79a966add25362c0.png",
  bannerUrl: "https://cdn.faire.com/fastly/c307368b3e07a1ac01a78f171d19d26b7fb3b20b3d69dbd2547e5ac82f293c4f.png",
  logoUrl: "https://cdn.faire.com/fastly/93c332c88a8735ba43f84251913dda2077aa173322778b8f79a966add25362c0.png",
  heroImageUrl: "https://cdn.faire.com/fastly/c307368b3e07a1ac01a78f171d19d26b7fb3b20b3d69dbd2547e5ac82f293c4f.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1495,
  isTopShop: true,
  isInsider: true,
  description: "Haute Diggity Dog was launched in 2004 as the original parody, plush dog toy company and quickly took the pet world by storm! Customers couldn’t live without their Chewy Vuitton plush handbag or their Jimmy Chew shoe toy.\n\nThe Haute Diggity Dog line of plush dog toys grew to include popular parody toys including Manolo Barknik, Tory Bark, Pawda, Arfsolut, Kennel One, Dog Perignon, Grrrona, Puptron, Furcedes, Starbarks, & many more! You can count on Haute Diggity Dog to bring you the most stylish & sophisticated toys, beds, and accessories for your four-legged friend. \n\nHaute Diggity Dog plush dog toys can be found in the finest pet boutiques and specialty stores across the United States and around the world.\n\nHaute Diggity Dog products may not be sold on Amazon or any other third-party websites.\n\nAll new accounts are subject to approval by Haute Diggity Dog\n\n**Champagne and Barkin Toys Cannot Be Sold In Europe Due To Trademark Issues",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:14:03.291Z",
    importedBy: "entity-db-cli"
  }
};
